import React from "react";
import LogoSvg from "../assets/5scarrental.svg";

export default function Logo(props) {
    return (
        <img style={{height: 50}} src={LogoSvg} alt="" {...props}/>
    )
}